<template lang="pug">
    div(ref='moveTarget',:style='style',class="drag-target",:data-transform-key='mykey')
      div(:style='style2')
        slot

</template>
<script>
import { cloneDeep } from 'lodash';
import Arrow from '@edit/atoms/Arrow.vue';
export default {
  props:{
    bounds:{
      type:Object,
      required:true
    },
    mykey:{
      type:String,
      required:true
    },
    transform:{
      type:Object,
      required:true
    },
    renderTools:{
      type:Object,
      required:true
    },
    parentHolder:{
      type:Object,
      required:true
    },
    moveable:{
      type:Object,
      required:true
    },
    updateContainerBounds:{
      type:Function,
      required:true
    },
    indirectlySelected:{
      type:Boolean,
      default:false
    },
    numSelections:{
      type:Number,
      default:1
    },
    renderer:{
      type:Object,
      required:true
    }

  },
  components:{
    Arrow,
  },
  data() {
    const {width,height,offset} = this.calculateSize();
    const pos = {
      x: (this.bounds.p1.x + this.bounds.p3.x)/2 + offset.x,
      y: (this.bounds.p1.y + this.bounds.p3.y)/2 + offset.y,
    }


    return {
      pos,
      width,
      height,
      style:{},
      style2:{},
      moved:{x:0,y:0}
    }
  },
  updated() {
  },
  mounted() {
    this.makeStyle();
    this.moveable.registerDrag(this.mykey, {
      onDragStart: this.onDragStart.bind(this),
      onDragEnd: this.onDragEnd.bind(this),
      onDrag: this.onDrag.bind(this),
      onRotateStart: this.onRotateStart.bind(this),
      onRotateEnd: this.onRotateEnd.bind(this),
      onRotate: this.onRotate.bind(this),
      onScaleStart: this.onScaleStart.bind(this),
      onScale: this.onScale.bind(this),
      onScaleEnd: this.onScaleEnd.bind(this)
    });
  },
  beforeDestroy() {
    if (this.moveable) {
      this.moveable.deregisterDrag(this.mykey);
      this.moveable.removeTarget(this.$refs.moveTarget);
    }
  },
  methods:{
    calculateSize() {
      const minSize = this.numSelections <= 1 ? 50 : 0;
      /*
      const width = Math.max(minSize, Math.max(
        Math.abs(this.bounds.p3.x - this.bounds.p1.x),
        Math.abs(this.bounds.p4.x - this.bounds.p2.x)
      ));
      */
      /*
      const height = Math.max(minSize, Math.max(
        Math.abs(this.bounds.p3.y - this.bounds.p1.y),
        Math.abs(this.bounds.p4.y - this.bounds.p2.y)
      ));
      */
      const localPos = {
        x:-0.5,
        y:-0.5
      }

      //let rotation = this.transform.transform.rotation % 2*Math.PI;
      const r = this.transform.transform.rotation;


      // Horrible quadrand hacks
      let rotation = r - Math.floor( r / (Math.PI*2)) * Math.PI*2;
      if (rotation > 3 * Math.PI/2) {
        rotation = 3 * Math.PI - rotation;
      }
      if (rotation > Math.PI) {
        rotation = 2 * Math.PI - rotation;
      }
      if (rotation >= Math.PI/2) {
        rotation = Math.PI - rotation;
      }

      // Cannot fix 45 degree problem because of PIXI
      // it just stores a top/left and width,height for bounds

      
      const cost = Math.cos(rotation);
      const sint = Math.sin(rotation);
      const bx = this.bounds.width;
      const by = this.bounds.height;

      const width = (1/(cost*cost - sint*sint)) * ( bx * cost  - by * sint );
      const height = (1/(cost*cost -sint*sint)) * ( -bx * sint + by * cost );

      const offset = {
        x:localPos.x * width,
        y:localPos.y * height
      }


      return {width,height,offset}
    },
    onDragStart() {
      // yeah, this is wrongly named. shoul be called 'interactivity-start' or something
      this.$emit('drag-start');

      this.unit = this.parentHolder.getLocalPointInParent({x:0,y:0});
      this.addedDragHandler = false;

      const {updateContainerBounds,indirectlySelected} = this;
      const id = this.transform.id;
      const {x,y} = this.transform.transform.pos;
      return {
        id,
        x,
        indirectlySelected,
        y,
        holder:this.parentHolder,
        updateContainerBounds
      }
    },
    onDragEnd() {
      // yeah, this is wrongly named. shoul be called 'interactivity-start' or something
      this.$emit('drag-end');
      this.renderTools.addToRunBatch( () => {
        this.updateContainerBounds(true);
      });
      this.renderTools.addToUpdateBatch(this.parentHolder, this.mykey);

      const {updateContainerBounds,indirectlySelected} = this;
      const id = this.transform.id;
      const {x,y} = this.transform.transform.pos;
      return {
        id,
        x,
        indirectlySelected,
        y,
        holder:this.parentHolder,
        updateContainerBounds
      }
    },
    onDrag({beforeDelta}) {

      this.moved.x += beforeDelta[0];
      this.moved.y += beforeDelta[1];

      if (this.addedDragHandler) {
        return;
      }
      this.addedDragHandler = true;
      this.renderTools.addToRunBatch( () => {
        this.addedDragHandler = false;
        this.$emit("dragging");

        this.pos.x += this.moved.x;
        this.pos.y += this.moved.y;

        this.$refs.moveTarget.style.left = this.pos.x + 'px';
        this.$refs.moveTarget.style.top = this.pos.y + 'px';

        if (!this.indirectlySelected) {
          let p = this.parentHolder.getLocalPointInParent({
            x: this.moved.x,
            y: this.moved.y
          });
          let delta = {
            x: p.x - this.unit.x,
            y: p.y - this.unit.y
          }
          delta = this.renderTools.screenToWorld(delta);

          this.transform.transform.pos.x += delta.x;
          this.transform.transform.pos.y += delta.y;

          this.renderTools.addToUpdateBatch(this.parentHolder, this.mykey);

        } else {
          /*
          this.renderTools.addToRunBatch( () => {
              this.updateContainerBounds(false);
          }, this.mykey + '-lol')
          */
        }

        this.moved.x = 0;
        this.moved.y = 0;
      }, 'drag-' + this.mykey);
    },
    onRotateStart() {
      // yeah, this is wrongly named. shoul be called 'interactivity-start' or something
      this.$emit('drag-start');
      const {updateContainerBounds,indirectlySelected} = this;
      const id = this.transform.id;
      const {rotation} = this.transform.transform;
      return {
        id, rotation,
        indirectlySelected, holder:this.parentHolder, updateContainerBounds
      }
    },
    onRotateEnd() {
      // yeah, this is wrongly named. shoul be called 'interactivity-start' or something
      this.$emit('drag-end');
      const {updateContainerBounds,indirectlySelected} = this;
      const id = this.transform.id;
      const {rotation} = this.transform.transform;
      return {
        id, rotation,
        indirectlySelected, holder:this.parentHolder, updateContainerBounds
      }
    },
    onRotate({beforeDelta, delta}) {
      this.renderTools.addToRunBatch( () => {
        const rotation = this.transform.transform.rotation;
        const newr = this.transform.transform.rotation + delta * Math.PI/180
        this.transform.transform.rotation = newr - Math.floor( newr / (Math.PI*2)) * Math.PI*2;
        const angle = this.transform.transform.rotation * 180/Math.PI;
        //this.$refs.moveTarget.style.transform = "rotate(" + angle +  "deg)";
        this.renderTools.addToUpdateBatch(this.parentHolder, this.mykey);
      });
    },
    onScaleStart({delta,...rest}) {
      // yeah, this is wrongly named. shoul be called 'interactivity-start' or something
      this.$emit('drag-start');
      const {updateContainerBounds,indirectlySelected} = this;
      const id = this.transform.id;
      const {scale,localScale} = this.transform.transform;
      this.initialScale = cloneDeep(this.transform.transform.scale);
      this.initialScaleLocal = cloneDeep(this.transform.transform.localScale);
      this.moveableScale = {x:1, y:1};
      return {
        id,
        scale: cloneDeep(scale),
        localScale: cloneDeep(localScale),
        indirectlySelected, holder:this.parentHolder, updateContainerBounds
      }
    },
    onScale({delta,scale,...rest}) {
      this.renderTools.addToRunBatch( () => {
        const rotation = this.transform.transform.rotation;
        //this.transform.transform.scale.x *= (delta[0]);
        //this.transform.transform.scale.y *= (delta[1]);
        this.transform.transform.scale.x = this.initialScale.x * scale[0];
        this.transform.transform.scale.y = this.initialScale.y * scale[1];

        const {x,y} = this.moveableScale;
        this.renderTools.addToUpdateBatch(this.parentHolder, this.mykey);
      });
    },
    onScaleEnd() {
      // yeah, this is wrongly named. shoul be called 'interactivity-start' or something
      this.$emit('drag-end');
      const {updateContainerBounds,indirectlySelected} = this;
      const id = this.transform.id;
      const {scale,localScale} = this.transform.transform;
      return {
        id,
        scale: cloneDeep(scale),
        localScale: cloneDeep(localScale),
        indirectlySelected, holder:this.parentHolder, updateContainerBounds
      }
    },
    makeStyle() {
      const rotation = this.transform.transform.rotation * 180 / Math.PI;
      this.style = {
        position:'absolute',
        'z-index':40,
        left:this.pos.x + 'px',
        top:this.pos.y + 'px',
        width:this.width + 'px',
        height:this.height + 'px',
        transform:`rotate(${rotation}deg)`
      }
      this.style2 = {
        position: 'relative',
        left:'0px',
        top:'0px',
        width:this.width + 'px',
        height:this.height + 'px'
      }
    }
  },
  computed:{
    /*
    style2() {
      //const width = this.width; 
      //const height = this.height;
      return {
        position: 'relative',
        left:'0px',
        top:'0px',
        width:this.width + 'px',
        height:this.height + 'px'
      }
    },
    style() {
      return {
        position:'absolute',
        'z-index':40,
        left:this.pos.x + 'px',
        top:this.pos.y + 'px',
        width:this.width + 'px',
        height:this.height + 'px'
      }
    }

*/
  },
  watch:{
    numSelections() {
      const previousWidth = this.width;
      const previousHeight = this.height;
      const {width,height,offset} = this.calculateSize();
      this.width = width;
      this.height = height;

      this.pos.x -= (width - previousWidth)/2;
      this.pos.y -= (height - previousHeight)/2;
    },
    'transform.transform': {
      handler(nv) {
        this.renderTools.addToUpdateBatch(this.parentHolder, this.mykey);
        this.updateContainerBounds(true);
        /*
        const {width,height,offset} = this.calculateSize();
        this.width = width;
        this.height = height;
        const pos = {
          x: (this.bounds.p1.x + this.bounds.p3.x)/2 + offset.x,
          y: (this.bounds.p1.y + this.bounds.p3.y)/2 + offset.y,
        }
        this.$set(this.pos, 'x', pos.x);
        this.$set(this.pos, 'y', pos.y);
        this.$nextTick( () => {
        this.$nextTick( () => {
        this.$nextTick( () => {
          this.moveable.updateRect();
        });
        });
        });
        */
      },
      deep: true
    },
    bounds: {
      handler(nv) {
        const {width,height,offset} = this.calculateSize();
        this.width = width;
        this.height = height;
        const pos = {
          x: (this.bounds.p1.x + this.bounds.p3.x)/2 + offset.x,
          y: (this.bounds.p1.y + this.bounds.p3.y)/2 + offset.y,
        }
        this.$set(this.pos, 'x', pos.x);
        this.$set(this.pos, 'y', pos.y);

        this.makeStyle();

        this.$nextTick( () => {
        this.$nextTick( () => {
        this.$nextTick( () => {
          this.moveable.updateRect();
        });
        });
        });
        //this.moveable.updateRect();
      },
      deep: true
    }
  }
}
</script>
